import * as constants from './constants'

export const fetchLocation = (id, requestId) => ({
    type: constants.FETCH_LOCATION,
    id,
    requestId,
})

export const fetchLocations = (params, page, requestId) => ({
    type: constants.FETCH_LOCATIONS,
    params,
    page,
    requestId,
})

export const fetchPlaceOfInterests = (id, requestId) => ({
    type: constants.FETCH_PLACE_OF_INTEREST,
    id,
    requestId,
})

export const fetchPlacesOfInterests = (params, requestId) => ({
    type: constants.FETCH_PLACES_OF_INTEREST,
    params,
    requestId,
})

export const receivedLocations = (result, requestId) => ({
    type: constants.RECEIVED_LOCATIONS,
    ...result,
    requestId,
})

export const receivedPlacesOfInterests = (result, requestId) => ({
    type: constants.RECEIVED_PLACES_OF_INTEREST,
    ...result,
    requestId,
})

export const failedToFetchLocations = () => ({
    type: constants.FAILED_TO_FETCH_LOCATIONS,
})

export const failedToFetchPOI = () => ({
    type: constants.FAILED_TO_FETCH_POINTS_OF_INTEREST,
})
